module.exports = __webpack_public_path__ + "img/solar.57fe2325.svg";